"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var actor_abstract_bindings_hash_1 = require("@comunica/actor-abstract-bindings-hash");

var bus_query_operation_1 = require("@comunica/bus-query-operation");

var asynciterator_promiseproxy_1 = require("asynciterator-promiseproxy");
/**
 * A comunica Minus Query Operation Actor.
 */


var ActorQueryOperationMinus =
/*#__PURE__*/
function (_actor_abstract_bindi) {
  _inherits(ActorQueryOperationMinus, _actor_abstract_bindi);

  function ActorQueryOperationMinus(args) {
    _classCallCheck(this, ActorQueryOperationMinus);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorQueryOperationMinus).call(this, args, 'minus'));
  }

  _createClass(ActorQueryOperationMinus, [{
    key: "newHashFilter",
    value: function newHashFilter(hashAlgorithm, digestAlgorithm, commons, hashes) {
      return function (bindings) {
        var hash = ActorQueryOperationMinus.hash(hashAlgorithm, digestAlgorithm, bindings.filter(function (v, k) {
          return commons[k];
        }));
        return !(hash in hashes);
      };
    }
  }, {
    key: "runOperation",
    value: function () {
      var _runOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(pattern, context) {
        var _this = this;

        var buffer, output, commons, hashes, bindingsStream;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = bus_query_operation_1.ActorQueryOperation;
                _context2.next = 3;
                return this.mediatorQueryOperation.mediate({
                  operation: pattern.right,
                  context: context
                });

              case 3:
                _context2.t1 = _context2.sent;
                buffer = _context2.t0.getSafeBindings.call(_context2.t0, _context2.t1);
                _context2.t2 = bus_query_operation_1.ActorQueryOperation;
                _context2.next = 8;
                return this.mediatorQueryOperation.mediate({
                  operation: pattern.left,
                  context: context
                });

              case 8:
                _context2.t3 = _context2.sent;
                output = _context2.t2.getSafeBindings.call(_context2.t2, _context2.t3);
                commons = this.getCommonVariables(buffer.variables, output.variables);

                if (!(Object.keys(commons).length !== 0)) {
                  _context2.next = 17;
                  break;
                }

                hashes = {};
                /**
                 * To assure we've filtered all B (`buffer`) values from A (`output`) we wait until we've fetched all values of B.
                 * Then we save these triples in a hashmap `hashes` and use the map to filter our A-stream.
                 */

                bindingsStream = new asynciterator_promiseproxy_1.PromiseProxyIterator(
                /*#__PURE__*/
                _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee() {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return new Promise(function (resolve) {
                            buffer.bindingsStream.on('data', function (data) {
                              var hash = ActorQueryOperationMinus.hash(_this.hashAlgorithm, _this.digestAlgorithm, data.filter(function (v, k) {
                                return commons[k];
                              }));
                              hashes[hash] = true;
                            });
                            buffer.bindingsStream.on('end', function () {
                              resolve();
                            });
                          });

                        case 2:
                          return _context.abrupt("return", output.bindingsStream.filter(_this.newHashFilter(_this.hashAlgorithm, _this.digestAlgorithm, commons, hashes)));

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })));
                return _context2.abrupt("return", {
                  type: 'bindings',
                  bindingsStream: bindingsStream,
                  variables: output.variables,
                  metadata: output.metadata
                });

              case 17:
                return _context2.abrupt("return", output);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function runOperation(_x, _x2) {
        return _runOperation.apply(this, arguments);
      }

      return runOperation;
    }()
    /**
     * This function puts all common values between 2 arrays in a map with `value` : true
     */

  }, {
    key: "getCommonVariables",
    value: function getCommonVariables(array1, array2) {
      return array1.filter(function (n) {
        return -1 !== array2.indexOf(n);
      }).reduce(function (m, key) {
        m[key] = true;
        return m;
      }, {});
    }
  }]);

  return ActorQueryOperationMinus;
}(actor_abstract_bindings_hash_1.AbstractFilterHash);

exports.ActorQueryOperationMinus = ActorQueryOperationMinus;